import { keyframes } from "@emotion/react";
import { Backdrop, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import LeafIcon from "./LeafIcon";

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
`;

const PulsingIcon = styled(LeafIcon)(({ theme }) => ({
  animation: `${pulse} 1.5s ease-in-out infinite`,
  fontSize: "3rem",
  color: theme.palette.primary.main,
}));

interface LoadingOverlayProps {
  open: boolean;
  message?: string;
}

export default function LoadingOverlay({ open, message = "Loading..." }: LoadingOverlayProps) {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
      open={open}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <PulsingIcon />
        <Typography variant="h5" component="div" textAlign="center">
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
}
